import { flushSync } from "react-dom";

let homeScroll = 0;

// 전역 scroll-behavior:smooth 때문에 전환 중 스크롤이 따로 움직이므로 항상 instant로 이동한다.
export function rememberScroll() {
  homeScroll = window.scrollY;
}

export function restoreScroll(fallbackId) {
  if (homeScroll > 0) {
    window.scrollTo({ top: homeScroll, left: 0, behavior: "instant" });
    return;
  }
  document.getElementById(fallbackId)?.scrollIntoView({ behavior: "instant", block: "start" });
}

export function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
}

// 이전 화면과 새 화면이 동시에 옆으로 밀리는 전환(맥 화면 전환 방식).
// View Transitions를 지원하지 않거나 모션 최소화 설정이면 즉시 전환한다.
export default function slideTo(navigate, to, options, direction = "forward") {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (typeof document.startViewTransition !== "function" || reduceMotion) {
    navigate(to, options);
    return;
  }

  root.dataset.slide = direction;
  const transition = document.startViewTransition(() => {
    flushSync(() => navigate(to, options));
  });
  transition.finished.finally(() => {
    delete root.dataset.slide;
  });
}
